import React from "react";
import styled from "styled-components";

const Container = styled.div`
  z-index: 1;
  padding-left: 24px;
  max-width: 70%;
  direction: rtl;
  text-align: right;
`;

export const PrivacyPolicyAr = (): React.ReactElement => {
  return (
    <Container>
      <h2>المزادات اإللكترونية لبرنامج األغذية العالمي</h2>
      <h3>سياسة الخصوصية</h3>
      <p>
        تحكم سياسة الخصوصية هذه الجمع وال ستخدام والكشف عن البيانات الشخصية من
        قبل أداة المزادات اللكترونية لبرنامج األغذية العالمي )المنصة(، وهي خدمة
        مشتركة عالمية يديرها برنامج األغذية العالمي حيث يمكن للمنظمات التابعة
        لألمم المتحدة والمنظمات غير .الحكومية والهيئات الحكومية واإلنسانية
        والتنموية المشاركة في المزادات
      </p>

      <h3>مقدمة</h3>
      <p>
        يلتزم برنامج األغذية العالمي بحماية خصوصية وسرية البيانات الشخصية
        لمستخدمي هذه المنصة اللكترونية. وتحدد هذه السياسة كيفية جمع واستخدام
        وحماية البيانات الشخصية التي يقدمها المستخدمون عند الوصول إلى المنصة
        واستخدامها
      </p>

      <h3>جمع واستخدام البيانات الشخصية</h3>
      <p>
        يعتبر برنامج األغذية العالمي الكائن في روما، إيطاليا، هو المتحكم في
        البيانات الشخصية المقدمة عبر المنصة. وإن استخدام المنصة ل يتطلب من
        المستخدم تقديم البيانات الشخصية الى برنامج األغذية العالمي. ولكن، يتوجب
        على المستخدمين التسجيل في المنصة لتقديم .عرض والمزايدة على المجموعات
        المطروحة للبيع :سيقوم برنامج األغذية العالمي، بصفته المتحكم في البيانات،
        بمعالجة ما يلي
      </p>
      <ul>
        <li>
          • تفاصيل التعريف والتصال الخاصة بالمستخدم وذلك إلدارة تسجيله في
          المنصة، وعند تقديمه عرضاً المزايدة؛
        </li>
        <li>
          المعلومات المرتبطة بالعرض أو المزايدة لتنفيذ عملية المزاد واتخاذ
          القرار بشأن تخصيصها.
        </li>
        <li>
          عند الدخول إلى المنصة، سيتم تخزين بعض المعلومات على خوادمنا وعلى
          برنامج تحليالت تابع لجهة خارجية مثل عناوين بروتوكول اإلنترنت والمتصفح
          المستخدم، والوقت المنقضي، مع معلومات أخرى مشابهة. يتم جمع هذه
          المعلومات من خالل ملفات تعريف الرتباط أو تقنيات مشابهة ويتم معالجتها
          لفهم تفضيالت مستخدمي المنصة بشكل أفضل وتحسين تجربتهم. ل يتم ربط هذه
          المعلومات بأي معرف مباشر يقدمه المستخدمين لنا. يمكن للمستخدمين استخدام
          إعدادات التصفح الخاصة بهم لرفض استخدام ملفات تعريف الرتباط والتقنيات
          المماثلة التي ليست أساسية لعمل المنصة بشكل صحيح.
        </li>
      </ul>

      <h3>االحتفاظ بالبيانات</h3>
      <p>
        سيقوم برنامج األغذية العالمي بالحتفاظ بالبيانات الشخصية طالما كان ذلك
        ضرورياً وفقاً ألنظمتنا الداخلية والقواعد المعمول بها، وفي .جميع الحالت،
        لفترة أقصاها 6 سنوات. بعد هذه الفترة، سيتم حذف البيانات الشخصية أو إخفاء
        هويتها
      </p>

      <h3>اإلفصاح للجهات الخارجية</h3>
      <p>
        ل يقوم برنامج األغذية العالمي بالكشف عن البيانات الشخصية إلى أطراف
        خارجية، إل بما هو ضروري للغاية ودذلك لتيسير الخدمات .( اً لألغراض
        المذكورة أعاله )على سبيل المثال، مزودو التكنولوجيا الذين يدعمون المنصة
        المطلوبة ووفق
      </p>

      <h3>التعديالت على سياسة الخصوصية</h3>
      <p>
        قد يتم تحديث سياسة الخصوصية للمنصة من وقت آلخر. يُنصح بمراجعة هذه
        السياسة بشكل دوري للبقاء على اطالع حول كيفية حماية .البيانات الشخصية
      </p>

      <h3>االمتيازات والحصانات</h3>
      <p>
        ل يُعتبر أي شيء في أو فيما يتعلق بهذه السياسة أو هذه الخدمة تنازلً عن أي
        من المتيازات والحصانات الخاصة ببرنامج األغذية العالمي .بموجب اتفاقية
        المتيازات والحصانات لألمم المتحدة واتفاقية المتيازات والحصانات للوكالت
        المتخصصة
      </p>

      <h3>حقوق حماية البيانات واالتصال</h3>
      <p>
        إلرسال األسئلة و/أو الطلبات للوصول إلى البيانات الشخصية، أو تصحيحها، أو
        حذفها، أو العتراض على معالجة أي نشاط، يرجى التواصل معنا عبر:
        support.auctiondigitaloffice@wfp
      </p>
    </Container>
  );
};
